import React from "react"

import EducationSection from "./EducationSection"
import WebSkills from "./WebSkills"
import GeneralSkills from "./GeneralSkills"
import ServerSkills from "./ServerSkills"
import SoftwareSkills from "./SoftwareSkills"
import ScriptingSkills from "./ScriptingSkills"
import OtherSkills from "./OtherSkills"

const SkillsView = () => {
  return (
    <div>
      <EducationSection />
      <GeneralSkills />
      <WebSkills />
      <ServerSkills />
      <SoftwareSkills />
      <ScriptingSkills />
      <OtherSkills />
    </div>
  )
}

export default SkillsView
